import { SubNavigation } from 'components/ui/SubNavigation/SubNavigation';
import { subNavigationConfig } from './StaticContentNavigation.constants';

const StaticContentNavigation = () => {
  return <SubNavigation config={subNavigationConfig} />;
};

export default StaticContentNavigation;
